import i18n from 'i18next';
import fi from './locales/fi/translation.json';
import en from './locales/en/translation.json';

i18n.init({
  lng: 'en',
  resources: {
    en: {
      translation: en
    },
    fi: {
      translation: fi
    }

  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js